
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hub/[hub]",
      function () {
        return require("private-next-pages/hub/[hub].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hub/[hub]"])
      });
    }
  